import React, { FC } from 'react'
import { Tooltip, VStack, Slider, SliderMark, SliderTrack, SliderFilledTrack, SliderThumb } from '@chakra-ui/react'
import { Button } from '../../components'
import { useTranslation } from 'react-i18next'

export interface SliderSavingsProps {
  onChange?: (newValues: string[]) => void
  onConfirm?: (values: string[]) => void
  name: string
}

export const SliderSavings: FC<SliderSavingsProps> = ({ onChange, name }) => {
  const { t } = useTranslation()
  const [sliderValue, setSliderValue] = React.useState(25)
  const [showTooltip, setShowTooltip] = React.useState(false)

  return (
    <VStack width="full" maxWidth={500} marginTop={5}>
      <Slider
        id="slider"
        defaultValue={25}
        min={0}
        name={name}
        max={100}
        height={100}
        colorScheme="teal"
        onChange={(e) => setSliderValue(e)}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
      >
        <SliderMark value={25} mt="1" ml="-2.5" fontSize="xs" color="darkGrey">
          25%
        </SliderMark>
        <SliderMark value={50} mt="1" ml="-2.5" fontSize="xs" color="darkGrey">
          50%
        </SliderMark>
        <SliderMark value={75} mt="1" ml="-2.5" fontSize="xs" color="darkGrey">
          75%
        </SliderMark>
        <SliderTrack backgroundColor="grey" height={3} borderRadius="full">
          <SliderFilledTrack backgroundColor="green.500" />
        </SliderTrack>
        <Tooltip
          hasArrow
          bg="green.500"
          color="white"
          placement="top"
          fontSize="xs"
          fontWeight="bold"
          isOpen={showTooltip}
          label={`${sliderValue}%`}
        >
          <SliderThumb boxSize={5} />
        </Tooltip>
      </Slider>
      <Button
        onClick={() => {
          onChange && onChange([sliderValue.toString()])
        }}
        variant="solid"
        color="purple"
        backgroundColor="purpleAlpha"
        fontSize="xs"
        fontWeight="bold"
        marginTop={40}
      >
        {t('common_confirm')}
      </Button>
    </VStack>
  )
}
